import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslocoPipe } from '@jsverse/transloco';
import { LanguageService } from '../../transloco/language.service';

/** EN/FR pill toggle. Expects a dark (primary) toolbar background. */
@Component({
  selector: 'lib-language-toggle',
  templateUrl: './language-toggle.component.html',
  styleUrl: './language-toggle.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoPipe]
})
export class LanguageToggleComponent {
  private languageService = inject(LanguageService);

  readonly currentLang = toSignal(this.languageService.langChanges$, { initialValue: this.languageService.currentLang });

  setLanguage(lang: string): void {
    this.languageService.setLanguage(lang);
  }
}
